import { render, staticRenderFns } from "./VisualizadorArchivos.vue?vue&type=template&id=446ad37a&scoped=true"
import script from "./VisualizadorArchivos.vue?vue&type=script&lang=js"
export * from "./VisualizadorArchivos.vue?vue&type=script&lang=js"
import style0 from "./VisualizadorArchivos.vue?vue&type=style&index=0&id=446ad37a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "446ad37a",
  null
  
)

export default component.exports